import { StateCreator } from "zustand";
import {
  AuthSlice,
  MessageSlice,
  SectionSlice,
  ThemeSlice,
  RegisterSlice,
  OptionSlice,
  OrganizationSlice,
} from "../../interfaces";

export const createRegisterSlice: StateCreator<
  RegisterSlice &
    SectionSlice &
    MessageSlice &
    AuthSlice &
    OptionSlice &
    OrganizationSlice &
    ThemeSlice,
  [["zustand/persist", unknown]],
  [],
  RegisterSlice
> = (set: any, get: any) => {
  return {
    registerDataZustand: {
      userEmail: "",
      userName: "",
      userSurname: "",
      userSocialName: "",
      userPassword: "",
      userPasswordConfirm: "",
      userLogoUrl: "",
      userPhoneNumber: "",
      subsidiaryName: "",
      subsidiaryAddress: "",
      subsidiaryTaxPayerID: "",
      subsidiaryLogoUrl: "",
    },
    setRegisterDataZustand(data) {
      set({
        registerDataZustand: data,
      });
    },
  };
};
